import React from 'react';
import {hydrate, render} from 'react-dom';
import {Provider} from 'react-redux';
import {configureStore} from '../../../shared/startup/configureStore';
import AbacusClientUtils, {logExperiment} from '@homeaway/abacus-client-utils';
import {SearchBoxLite} from '../../../shared/components/common/searchboxlite/SearchBoxLite';
import MvtTest from '../../../shared/components/common/mvt/MvtTest/MvtTest';
import {TESTS} from '../../../shared/utils/abacus';
import {withErrorBoundary} from '../../../shared/components/common/error-boundary/ErrorBoundary';

/* eslint consistent-return:0 */
export default function hydrateApp() {
    // Grab the state from a global injected into server-generated HTML
    const preloadedState = window.__PRELOADED_STATE__;

    // Create Redux store with initial state
    const store = configureStore({
        initialState: preloadedState
    });

    const {abacus, config} = store.getState();

    AbacusClientUtils.initialize(abacus);

    if (config.context.bodyConfig.exposeSplitHydrate) {
        logExperiment(abacus[TESTS.SPLIT_HYDRATE]);
    }

    hydrate(
        <Provider store={store}>
            <SearchBoxLite />
        </Provider>,
        document.querySelector('.searchbox-root')
    );

    import(
        /* webpackChunkName: "site-header" */
        /* webpackPreload: true */
        '../../../shared/components/common/site-header/SiteHeader'
    ).then((module) => {
        const SiteHeader = module.default;
        render(
            <Provider store={store}>
                {withErrorBoundary(
                    <MvtTest test={TESTS.WHITE_HEADER} report reportOnMount>
                        <SiteHeader />
                    </MvtTest>
                )}
            </Provider>,
            document.querySelector('.site-header-root')
        );
    });

    import(
        /* webpackChunkName: "content-g2-split-hydrate" */
        /* webpackPreload: true */
        '../../../shared/templates/g2-split-hydrate'
    ).then(({Template}) => {
        hydrate(
            <Provider store={store}>
                <Template />
            </Provider>,
            document.querySelector('.content-root')
        );
    });

    import(
        /* webpackChunkName: "site-footer" */
        '../../../shared/components/common/site-footer/AsyncSiteFooter'
    ).then(({AsyncSiteFooter}) => {
        render(
            <Provider store={store}>
                {withErrorBoundary(<AsyncSiteFooter />)}
            </Provider>,
            document.querySelector('.site-footer-root')
        );
    });
}
